import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  dotNumberValidation,
  dotNumberBlurValidation,
  withDotValidation,
} from "../../../../helpers/global_helper";
import ConfirmBetDeskonPopup from "../../../Popups/ConfirmBetDeskonPopup";
import BetSuccessPopup from "../../../Popups/BetSuccessPopup";
import ErrorPopup from "../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../Popups/ErrorInnerPopup";
import CancelledBetDeskonPopup from "../../../Popups/CancelledBetDeskonPopup";
import { withTranslation } from "react-i18next";
import { getUserBalance, setCommonConfig } from "../../../../redux/actions";
import GameClosedPopup from "../GameClosedPopup";
import MarketClose from "../MarketClose";
import { formatPrice } from "../../../NumberFormat";
import CommonBetHeader from "../CommonBetHeader";

const Shio = (props) => {
  const dispatch = useDispatch();
  const device = useSelector((state) => state.CommonConfig.device_type);
  const [rowsToShow, setRowsToShow] = useState(10);
  const initialRowData = Array.from({ length: rowsToShow }, () => ({
    guess: "",
    bet: "",
  }));
  const [rowData, setRowData] = useState(initialRowData);
  const [submitReqData, setSubmitReqData] = useState({
    gameId: null,
    gameType: "shio",
    dataangka: [],
    action: "process",
    betTogelAuth: "betTogelAuth",
  });
  const [showGameClose, setShowGameClose] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [diskon, setDiskon] = useState({});
  const [bolakBalik, setBolakBalik] = useState({});
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [reqData, setReqData] = useState({
    gameId: gameId,
    gameType: "shio",
  });
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [SubmitRespData, setSubmitRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [totalBetAmount, setTotalBetAmount] = useState(0);
  const [defaultValue, setDefaultvalue] = useState("")

  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };

  const handleInputChange = (e, rowIndex, columnName) => {
    const { value, name } = e.target;

    let newDiskon = 0;
    let newBolakBalik = 0;
    let minValue = null;
    let maxValue = null;
    const numericValue = parseFloat(value);
    if (columnName == "bet") {
      minValue = betDiscount.showMin / 1000;
      maxValue = betDiscount.showMax / 1000;

      newDiskon = (numericValue * betDiscount.showDisc * betDiscount.showMultiple) / 100;
      newBolakBalik = numericValue * betDiscount.showMultiple - newDiskon;

      setBolakBalik((prevBolakBalik) => ({
        ...prevBolakBalik,
        [rowIndex]: newBolakBalik,
      }));
      setDiskon((prevDiskon) => ({
        ...prevDiskon,
        [rowIndex]: newDiskon,
      }));

      let regex = '';
      if (String(betDiscount.showMin).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }

      if (!regex.test(value)) {
        clearBetValue(rowIndex, columnName);
      } else if (value < minValue) {
        setShowErrorPopup(true);
        setErrorMessage("Minimum bet is 1");
        const newDiskon = { ...diskon };
        delete newDiskon[rowIndex];
        setDiskon(newDiskon);
        const newBolakBalik = { ...bolakBalik };
        delete newBolakBalik[rowIndex];
        setBolakBalik(newBolakBalik);
        clearBetValue(rowIndex, columnName);
      } else if (value > maxValue) {
        setErrorMessage(props.t("The_bet_has_exceeded_the_maximum_bet"));
        setShowErrorPopup(true);
        const newDiskon = { ...diskon };
        delete newDiskon[rowIndex];
        setDiskon(newDiskon);
        const newBolakBalik = { ...bolakBalik };
        delete newBolakBalik[rowIndex];
        setBolakBalik(newBolakBalik);
        clearBetValue(rowIndex, columnName);
      } else {
        const updatedRowData = rowData.map((row, index) => {
          if (index === rowIndex) {
            return { ...row, [columnName]: value };
          }
          return row;
        });
        setRowData(updatedRowData);
      }
    } else {
      const updatedRowData = rowData.map((row, index) => {
        if (index === rowIndex) {
          return { ...row, [columnName]: value };
        }
        return row;
      });
      setRowData(updatedRowData);
    }
  };

  const [bets, setBets] = useState(
    Array.from({ length: 20 }, (_, index) => ({
      guess: '',
      bet: '',
    }))
  );

  const handleInputBlur = (index, value, betTypeId, columnName) => {
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    handleInputChange1(index, value, betTypeId, columnName);
  }


  const handleInputChange1 = (index, value, betTypeId, columnName) => {
    let newDiskon = 0;
    let newBolakBalik = 0;
    let minValue = null;
    let maxValue = null;
    value = value.replace(',', '.');

    let regex;
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    const numericValue = parseFloat(value);

    if (columnName === "bet") {
      minValue = betDiscount.showMin / 1000;
      maxValue = betDiscount.showMax / 1000;

      newDiskon = ((numericValue * betDiscount.showDisc * betDiscount.showMultiple) / 100).toFixed(1);
      newDiskon = fixDecimal(newDiskon);

      newBolakBalik = numericValue * betDiscount.showMultiple - newDiskon;

      setBolakBalik((prevBolakBalik) => ({
        ...prevBolakBalik,
        [index]: newBolakBalik,
      }));
      setDiskon((prevDiskon) => ({
        ...prevDiskon,
        [index]: newDiskon,
      }));


      if (!regex.test(value)) {
        return;
        // clearBetValue(index, columnName);
      }
      // else if (value < minValue && value) {
      //   setShowErrorPopup(true);
      //   setErrorMessage(props.t('minimum_bet_is_1'));

      //   clearBetValue(index, columnName);

      //   const newDiskon = { ...diskon };
      //   delete newDiskon[index];
      //   setDiskon(newDiskon);

      //   const newBolakBalik = { ...bolakBalik };
      //   delete newBolakBalik[index];
      //   setBolakBalik(newBolakBalik);
      // } 
      else if (value > maxValue) {
        setErrorMessage(props.t("The_bet_has_exceeded_the_maximum_bet"));
        setShowErrorPopup(true);

        clearBetValue(index, columnName);

        const newDiskon = { ...diskon };
        delete newDiskon[index];
        setDiskon(newDiskon);

        const newBolakBalik = { ...bolakBalik };
        delete newBolakBalik[index];
        setBolakBalik(newBolakBalik);
      } else {
        const updatedBets = [...bets];
        updatedBets[index].bet = value;
        updatedBets[index].guess = betTypeId;

        const totalAmount = updatedBets.reduce((sum, bet) => {
          const betValue = parseFloat(bet.bet) || 0;
          return sum + (betValue * betDiscount.showMultiple);
        }, 0);

        const totalAmount1 = totalAmount - (totalAmount * (betDiscount.showDisc / 100));

        setBets(updatedBets);
        setTotalBetAmount(totalAmount1);
        setRowData(updatedBets);
      }
    }
  };

  const fixDecimal = value => {
    if (Array.isArray(value)) {
      return value.map(item => fixDecimal(item));
    }
    return !isNaN(value) ? parseFloat(parseFloat(value).toFixed(1)) : value;
  };

  const handleBetInputClick = (index, betTypeId) => {
    if (defaultValue > 0) {
      const updatedBets = [...bets];
      updatedBets[index].bet = defaultValue;
      updatedBets[index].guess = betTypeId;

      const totalAmount = updatedBets.reduce((sum, bet) => {
        const betValue = parseFloat(bet.bet) || 0;
        return sum + (betValue * betDiscount.showMultiple);
      }, 0);

      const totalAmount1 = totalAmount - (totalAmount * (betDiscount.showDisc / 100));

      setBets(updatedBets);
      setTotalBetAmount(totalAmount1);
      setRowData(updatedBets);

      let newDiskon = ((defaultValue * betDiscount.showDisc * betDiscount.showMultiple) / 100).toFixed(1);
      newDiskon = fixDecimal(newDiskon);
      const newBolakBalik = defaultValue * betDiscount.showMultiple - newDiskon;

      setDiskon((prevDiskon) => ({
        ...prevDiskon,
        [index]: newDiskon,
      }));

      setBolakBalik((prevBolakBalik) => ({
        ...prevBolakBalik,
        [index]: newBolakBalik,
      }));
    }
  };


  const clearBetValue = (rowIndex, columnName) => {
    const updatedRowData = rowData.map((row, index) => {
      if (index === rowIndex) {
        return { ...row, bet: "" };
      }
      return row;
    });
    setRowData(updatedRowData);

    const updatedBets = [...bets];
    updatedBets[rowIndex][columnName] = '';
    setBets(updatedBets);

    const totalAmount = updatedBets.reduce((sum, bet) => {
      const betValue = parseFloat(bet.bet) || 0;
      return sum + (betValue * betDiscount.showMultiple);
    }, 0);

    const totalAmount1 = totalAmount - (totalAmount * (betDiscount.showDisc / 100));
    setTotalBetAmount(totalAmount1);

    if (document.activeElement.tagName === 'INPUT') {
      document.activeElement.blur();
    }
  };

  useEffect(() => {
    makeAjax(url.TOGEL_API.getTogelGame, reqData)
      .then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
          if (response.code !== "validation_error") {
            setErrorMessage(props.t(response.code));
            setShowErrorPopup(true);
            return;
          }
          showMessage("server error No data find", "error", "error");
          return;
        }
        setDropdownOptions(response.data.shio);
      })
      .catch((error) => {
        setShowErrorPopup(true);
        setErrorMessage("Repeated numbers are not allowed");
      });
  }, [reqData]);

  useEffect(() => {
    const filteredRowData = rowData.filter((row) => row.guess !== "");

    const newDataangka = filteredRowData.map((row) => {
      return [row.guess, row.bet * betDiscount.showMultiple, "success"];
    });

    setSubmitReqData((prevState) => ({
      ...prevState,
      gameId: gameId,
      dataangka: newDataangka,
    }));
  }, [rowData]);

  useEffect(() => {
    resetAllData();
  }, [gameId]);

  const resetAllData = () => {
    setRowData(initialRowData);
    setSubmitReqData({
      gameId: null,
      gameType: "shio",
      dataangka: [],
      action: "process",
      betTogelAuth: "betTogelAuth",
    });
    setErrorMessage("");
    setShowErrorPopup(false);
    setShowConfirmationPopup(false);
    setSubmitRespData([]);
    setSuccessPopup(false);
    setDiskon("");
    setBolakBalik("");
    setDefaultvalue("");
    setTotalBetAmount(0);
    setBets(Array.from({ length: 20 }, () => ({
      guess: '',
      bet: '',
    })));
  };
  const rowDataReset = (rowIndex) => {
    // Update state for 'guess' and 'bet' fields in the rowData array
    setRowData((prevRowData) => {
      const updatedRowData = [...prevRowData]; // Create a copy of the rowData array
      updatedRowData[rowIndex] = { guess: "", bet: "" }; // Reset the specific row
      return updatedRowData;
    });
    setDiskon((prev) => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });

    setBolakBalik((prev) => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });
  };
  const submitProcess = (event) => {
    const isValid = rowData.some((row) => row.guess !== "" && row.bet !== "");

    // for (let row of rowData) {
    //   if (row.guess !== "" && row.bet === "") {
    //     setErrorMessage("If a guess is selected, the bet field is mandatory.");
    //     setShowErrorPopup(true);
    //     return;
    //   }
    // }

    if (!isValid) {
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
      return;
    } else {
      setShowConfirmationPopup(true);
    }
  };

  const filteredDataangka = submitReqData.dataangka.filter(
    (item) => item[1] !== 0
  );

  const requestData = { ...submitReqData, dataangka: filteredDataangka };

  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.processAltTogel, requestData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code))
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      resetAllData();
      setBets(Array.from({ length: 20 }, () => ({
        guess: '',
        bet: '',
      })));
      setSubmitRespData((prevData) => [...prevData, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);
    });
  };
  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };
  // const validStyle = {
  //   backgroundColor: "#CEE5FF",
  // };

  const handleDeafultInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (value > betDiscount.showMax / 1000) {
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }
    if (regex.test(value)) {
      setDefaultvalue(value);
    }
  };

  const handleDeafultInputBlur = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultvalue(value);
    }
  };

  return (
    <div className="shio_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          <div className="shio_container" style={{ flexDirection: "column" }}>
            {/*  <table>
              <thead>
                <tr>
                  <th colSpan="2"></th>
                  <th style={{ whiteSpace: "nowrap", textAlign: "center", paddingRight: 5 }} colSpan={2}>
                    Nominal Bet IDR 1 = 1000
                  </th>
                  <th className="total_pay link2" colSpan="3" style={{ whiteSpace: "nowrap", textAlign: "right", paddingRight: 5 }}>
                    Total Bet:<span className="betdiskon_total_discount">
                      {totalBetAmount == null ? 0 : formatPrice(totalBetAmount)}
                    </span>
                  </th>
                </tr>
              </thead>
            </table> */}
            <CommonBetHeader rowsToShow={null} gameName="shio" bbPayAmount={0} totalBetAmount={totalBetAmount} handleRowsToShowChange={null} />
            <table>
              <thead>
                <tr className="Heading">
                  <th>{props.t("no.")}</th>
                  <th>{props.t("guess")}</th>
                  <th>
                    {/* <label htmlFor="belliInput">{props.t('buy')}</label> */}
                    <input
                      id="inputs"
                      type="text"
                      autoComplete="off"
                      placeholder="Auto Bet"
                      // className="small_input"
                      value={defaultValue}
                      onChange={handleDeafultInputChange}
                      onBlur={handleDeafultInputBlur}
                    />
                  </th>
                  {device === "Desktop" ? (
                    <>
                      <th>{props.t("discount")}</th>
                      <th>{props.t("pay")}</th>
                    </>
                  ) : null}
                </tr>
              </thead>
              <tbody>
                {dropdownOptions.map((option, index) => (
                  <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                    <td>{index + 1}</td>
                    <td>{option?.name.charAt(0).toUpperCase() + option?.name.slice(1)}</td>
                    <td className="inputs">
                      <input
                        type="text"
                        placeholder="Bet"
                        inputMode="decimal"
                        pattern="[0-9]*[.,]?[0-9]**"
                        value={bets[index]?.bet || ''}
                        onChange={(e) => handleInputChange1(index, e.target.value, option.bet_type_id, 'bet')}
                        onBlur={(e) => handleInputBlur(index, e.target.value, option.bet_type_id, 'bet')}
                        onClick={() => handleBetInputClick(index, option.bet_type_id)}
                      />
                      <input type="hidden" value={option?.bet_type_id} />
                    </td>
                    {device === "Desktop" ? (
                      <>
                        <td>
                          <input
                            type="text"
                            value={diskon[index] != '' && !isNaN(diskon[index]) ? formatPrice(diskon[index]) : ''}
                            readOnly
                            tabIndex="-1"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={bolakBalik[index] ? formatPrice(bolakBalik[index]) : ''}
                            readOnly
                            tabIndex="-1"
                          />
                        </td>
                      </>
                    ) : null}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="last_div">
            <div className="left_div">
              <p>{props.t("shio_2d")}</p>
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button className="reset" onClick={resetAllData}>
                    {props.t('reset')}
                  </button>
                </li>
                <li>
                  <button className="submit" onClick={submitProcess}>
                    {props.t('submit')}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          submitProcessOk={submitProcessOk}
        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCanclledPopup(false)} />
      )}
      {successPopup && (
        <div className="popup-overlay">
          <BetSuccessPopup
            response={SubmitRespData}
            onClose={() => setSuccessPopup(false)}
          />
        </div>
      )}
      {showErrorPopup && (
        <ErrorInnerPopup
          modalTitle={""}
          modalHeader={true}
          onCloseModal={() => setShowErrorPopup(false)}
        >
          <ErrorPopup
            message={errMessage}
            onClose={() => setShowErrorPopup(false)}
          />
        </ErrorInnerPopup>
      )}
    </div>
  );

};

export default withTranslation()(Shio);
